import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Sale } from '@/types/entities'
import { StatusBadge } from '@/components/common/data-display/StatusBadge'
import { formatCurrency, formatDate } from '@/lib/utils'
import { cn } from '@/lib/utils'

interface SalesTableProps {
  sales: Sale[]
  onRowClick?: (sale: Sale) => void
}

export function SalesTable({ sales, onRowClick }: SalesTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Order ID</TableHead>
            <TableHead>Date</TableHead>
            <TableHead>Artwork</TableHead>
            <TableHead>Vendor</TableHead>
            <TableHead>SKU</TableHead>
            <TableHead className="text-right">Qty</TableHead>
            <TableHead className="text-right">Price</TableHead>
            <TableHead className="text-right">Commission</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sales.map((sale) => (
            <TableRow
              key={sale.id}
              className={cn(onRowClick && 'cursor-pointer hover:bg-muted/50')}
              onClick={() => onRowClick?.(sale)}
            >
              <TableCell className="font-medium">{sale.orderId}</TableCell>
              <TableCell>{formatDate(sale.orderClosedDate)}</TableCell>
              <TableCell className="max-w-xs truncate">{sale.artworkName}</TableCell>
              <TableCell className="max-w-xs truncate">{sale.vendorName}</TableCell>
              <TableCell className="font-mono text-xs">{sale.productSku}</TableCell>
              <TableCell className="text-right">{sale.productQuantity}</TableCell>
              <TableCell className="text-right">{formatCurrency(sale.productPrice)}</TableCell>
              <TableCell className="text-right font-semibold text-green-600">
                {formatCurrency(sale.commission)}
              </TableCell>
              <TableCell>
                <StatusBadge status={sale.orderStatus} size="sm" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

